






































import { computed, defineComponent, SetupContext, ComponentPropsOptions } from '@vue/composition-api';
import { LoadingIcon, CheckCircleFilledIcon, ErrorCircleFilledIcon } from 'tdesign-icons-vue';
interface PropData {
  file: File;
  disableConfirm: boolean;
  // fileName: string,
  uploadStatus: string;
  rule: {
    validator: (file: File) => boolean;
    message: string;
  };
  beforeUpload: (file: File) => boolean | Promise<boolean>;
}
export default defineComponent({
  components: {
    LoadingIcon,
    CheckCircleFilledIcon,
    ErrorCircleFilledIcon,
  },
  props: {
    disableConfirm: {
      type: Boolean,
      default: false,
    },
    uploadStatus: {
      type: String,
      default: '',
    },
    file: {
      required: true,
      type: [File, Object],
      default: () => ({
        name: '',
      }),
    },
    rule: {
      type: Object,
      required: true,
      default: () => ({
        accept: '',
        validator(val: any): boolean {
          return true;
        },
        message: '',
      }),
    },
    beforeUpload: {
      type: Function,
      default: () => true,
    },
  },
  setup(props: PropData, context: SetupContext) {
    const innerFile = computed<
      | File
      | {
          name: string;
        }
    >({
      set(
        val:
          | File
          | {
              name: string;
            },
      ) {
        context.emit('update:file', val);
      },
      get() {
        return props.file;
      },
    });
    const filename = computed(() => innerFile.value?.name || '');
    const methods = {
      beforeUploadFn(_file: File) {
        // 若有校验函数且校验不通过，则取消上传
        if (!props.rule.validator(_file)) return false;
        innerFile.value = _file;
        return props.beforeUpload(_file);
      },
      onDelete() {
        innerFile.value = {
          name: '',
        };
        context.emit('delete');
      },
    };
    return {
      innerFile,
      filename,
      ...methods,
    };
  },
});
